var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSetOrg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12.75V11.75C3.75 11.2196 3.96071 10.7109 4.33579 10.3358C4.71086 9.96071 5.21957 9.75 5.75 9.75H13.75C14.2804 9.75 14.7891 9.96071 15.1642 10.3358C15.5393 10.7109 15.75 11.2196 15.75 11.75V12.75M9.75 6.75V9.75M2.75 12.75H4.75C5.85457 12.75 6.75 13.6454 6.75 14.75V16.75C6.75 17.8546 5.85457 18.75 4.75 18.75H2.75C1.64543 18.75 0.75 17.8546 0.75 16.75V14.75C0.75 13.6454 1.64543 12.75 2.75 12.75ZM14.75 12.75H16.75C17.8546 12.75 18.75 13.6454 18.75 14.75V16.75C18.75 17.8546 17.8546 18.75 16.75 18.75H14.75C13.6454 18.75 12.75 17.8546 12.75 16.75V14.75C12.75 13.6454 13.6454 12.75 14.75 12.75ZM8.75 0.75H10.75C11.8546 0.75 12.75 1.64543 12.75 2.75V4.75C12.75 5.85457 11.8546 6.75 10.75 6.75H8.75C7.64543 6.75 6.75 5.85457 6.75 4.75V2.75C6.75 1.64543 7.64543 0.75 8.75 0.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetOrg);
export default __webpack_public_path__ + "static/media/icon_set_org.d5e61a9fffbdb47d437596f71b7d39e8.svg";
export { ForwardRef as ReactComponent };